class ProductUI {

    constructor(products, config = {}) {
        this._config = _.extend({
            options: {},
            option_images: {},
            aspect_ratios: {
                '7x5': '3_2',
                '30x20': '3_2',
                '36x24': '3_2',
                '51x34': '3_2',
                '34x51': '3_2',
                '60x40': '4_3',
                '10x8': '5_4',
                '14x11': '5_4',
                '20x16': '5_4',
                '24x18': '4_3',
                '40x30': '4_3',
                '18x10': '16_9',
                '25x12': '25_12',
                '42x17': '42_17',
                '5x7': '2_3',
                '20x30': '2_3',
                '24x36': '2_3',
                '8x10': '4_5',
                '11x14': '4_5',
                '16x20': '4_5',
                '18x24': '3_4',
                '30x40': '3_4',
                '34x51': '3_4',
                '40x60': '3_4',
                '10x18': '9_16',
                '12x25': '12_25',
                '17x42': '17_42'
            }
        }, config);

        this.defaults = {
            canvas: {
                material: 'canvas',
                size: '8x10',
                frame_type: 'Stretched',
                frame_finish: null,
                mat: 'No Mat'
            },
            paper: {
                material: 'paper',
                size: '5x7',
                frame_finish: 'no frame',
                frame_type: null,
                mat: 'No Mat'
            },
            download: {
                material: 'digital download',
                size: null,
                frame_finish: null,
                frame_type: null,
                mat: null
            },
            empty: {
                material: null,
                size: null,
                frame_finish: null,
                frame_type: null,
                mat: null
            }
        };

        this.product = products[0];
        this.related_products = products;
        this.tags = this.product.tags.split(', ');
        this.type = this.product.product_type;
        this.variants = _.flatten(_.map(products, 'variants'));
        this.product_options = this.product.options;
        this.all_options = this.related_products.reduce((opts, p) => ([...opts, ...p.options]), []);
        this.options_map = {
            option1: this.all_options.filter(opt => (opt.position == 1)),
            option2: this.all_options.filter(opt => (opt.position == 2)),
            option3: this.all_options.filter(opt => (opt.position == 3))
        };
        this.aspect_ratios = this._config.aspect_ratios

        this._opts = _.extend({}, this.defaults.paper);
        this.frame_images = this._config.option_images;
        this.updating = false;
        this.init();
    }

    get material() {
        return this._opts.material;
    }
    set material(v) {
        if (v == 'digital download') v = 'download';
        let original_val = this.material;
        this._opts.material = v;
        this.elements.inputs.material.forEach(input => {
            input.firstElementChild.classList.remove('active');
            if (input.dataset.value == this.material) {
                input.firstElementChild.classList.add('active');
            }
        });
        this.onOptionsChanged('material', original_val, this.material);

    }
    get size() {
        return this._opts.size;
    }
    set size(v) {
        let original_val = this.size;
        this._opts.size = v;
        this.elements.inputs.size.forEach(input => {
            let radio = input.querySelector('input');
            if (this.size && input.dataset.value.toLowerCase() == this.size.toLowerCase()) {
                radio.checked = true;
            }
        });

        this.onOptionsChanged('size', original_val, this.size);
    }
    get frame_finish() {
        return this._opts.frame_finish;
    }
    set frame_finish(v) {
        let original_val = this.frame_finish;
        this._opts.frame_finish = v;
        this.elements.inputs.frame_finish.forEach(input => {
            let radio = input.querySelector('input');
            if (this.frame_finish && input.dataset.value.toLowerCase() == this.frame_finish.toLowerCase()) {
                radio.checked = true;
            } else {
                radio.checked = false;
            }
        });

        this.onOptionsChanged('frame_finish', original_val, this.frame_finish);
    }
    get frame_type() {
        return this._opts.frame_type;
    }
    set frame_type(v) {
        let original_val = this.frame_type;
        this._opts.frame_type = v;
        this.elements.inputs.frame_type.forEach(input => {
            let radio = input.querySelector('input');
            if (this.frame_type && input.dataset.value.toLowerCase() == this.frame_type.toLowerCase()) {
                radio.checked = true;
            } else {
              radio.checked = false;
            }
        });

        this.onOptionsChanged('frame_type', original_val, this.frame_type);
    }
    get mat() {
        return this._opts.mat;
    }
    set mat(v) {
        let original_val = this.mat;
        this._opts.mat = v;
        this.elements.inputs.mat.forEach(input => {
            let radio = input.querySelector('input');
            if (this.mat && input.dataset.value.toLowerCase() == this.mat.toLowerCase()) {
                radio.checked = true;
            }
        });

        this.onOptionsChanged('mat', original_val, this.mat);
    }
    set options(opts) {
        let init_updates = !this.updating;
        this.updating = true;
        if (this.updating)
        Object.entries(_.pick(opts, Object.keys(this._opts))).forEach((opt) => {
            this[opt[0]] = opt[1];
        });
        if (init_updates) {
            //this.updateUrl();
            this.updateVariant();
            this.updateImageDisplay();
            this.updating = false;
        }
    }
    get options() {
        return this._opts;
    }
    get price() {
        return this.getVariant().price;
    }
    get product_type() {
        let product_type = null;

        if (this.isCanvas()) {
            product_type = 'canvas ' + (this.hasFrame() ? this.frame_type.toLowerCase() : 'non framed');
        } else if (this.isPaper()) {
            product_type = 'paper ' + (this.hasFrame() ? this.mat.toLowerCase() : 'non framed');
        } else {
            product_type = 'digital download';
        }

        return product_type;
    }
    set product_type(type) {
        let new_product = this.related_products.find(p => {
            return p.product_type.toLowerCase() == type;
        });

        if (new_product && this.product.product_type.toLowerCase() != type) {
            this.product = new_product;
        }
    }

    init = () => {
        this.log('initializing...');

        this.initElements();
        this.elements.product_section.classList.add('ui-loading');
        this.initListeners();
        this.initOptions();
        this.updateImageDisplay();
        this.elements.product_section.classList.remove('ui-loading');
    }

    initOptions = () => {
        this.resetOptions(this.getQueryOptions(true));
    }

    initListeners = () => {
        _.forEach(_.flatten(_.values(this.elements.inputs)), (function (input) {
            input.addEventListener('click', this._handleClick);
            input.addEventListener('touchend', this._handleClick);
        }).bind(this));
    }

    initElements = () => {
        this.elements = {
            inputs: {
                material: [...document.querySelectorAll('[data-option*="material"]')],
                size: [...document.querySelectorAll('[data-option*="size"]')],
                frame_finish: [...document.querySelectorAll('[data-option*="frame-finish"]')],
                frame_type: [...document.querySelectorAll('[data-option*="frame-type"]')],
                mat: [...document.querySelectorAll('[data-option*="mat"]')],
            },
            input_groups: {
                material: document.getElementById('option-material'),
                size: document.getElementById('option-choose-size-w-h'),
                frame_finish: document.getElementById('option-frame-finish'),
                frame_type: document.getElementById('option-frame-type'),
                mat: document.getElementById('option-mat'),
            },
            price: {
                regular: [...document.querySelectorAll('.f-price .f-price__regular .f-price-item')],
                sale: [...document.querySelectorAll('.f-price .f-price__sale .f-price-item.f-price-item--sale')],
                compare: [...document.querySelectorAll('.f-price .f-price__sale .f-price-item.f-price-item--regular')],
                container: [...document.querySelectorAll('.f-price.f-price--large')],
                all_containers: [...document.querySelectorAll('dl.price:not(.price--listing)')]
            },
            dynamic_frames: [...document.querySelectorAll('.dynamic-frames-container .product-single__media-wrapper.first-wrapper .f-image')],
            image_wrappers: [...document.querySelectorAll('.product-single__media-wrapper.first-wrapper')],
            variant_id_inputs: [...document.querySelectorAll('input[name=id]')],
            //product_id_inputs: [...document.querySelectorAll('input[name="product-id"]')],
            product_section: document.querySelector('.f-product-single[data-section-type=main-product]'),
            product_tabs_container: document.querySelector('.f-product-tabs__wrapper')
        }
    }

    resetOptions = (opts = {}) => {
        opts = _.extend({
            material: 'paper',
            size: null,
            frame_finish: null,
            frame_type: null,
            mat: null
        }, opts);
      	if (Object.hasOwnProperty.call(opts, 'variant')) {
          opts = _.extend({}, this.getVariantOptions(opts.variant));
     	}

        var opt_groups = this.elements.input_groups;
        if (!this.isHiddenGroup(opt_groups.material)) {
            this.options = {material: opts.material || this.getFirstAvailable('material')};
        }
        if (!this.isHiddenGroup(opt_groups.size)) {
            this.options = {size: opts.size || this.getFirstAvailable('size')};
        } else {
            this.options = {size: null};
        }
        if (!this.isHiddenGroup(opt_groups.frame_type)) {
            this.options = {frame_type: opts.frame_type || this.getFirstAvailable('frame_type')};
        }
        if (!this.isHiddenGroup(opt_groups.frame_finish)) {
            this.options = {frame_finish: opts.frame_finish || this.getFirstAvailable('frame_finish')};
        }
        if (!this.isHiddenGroup(opt_groups.mat)) {
            this.options = {mat: opts.mat || this.getFirstAvailable('mat')};
        }
    }

    getFirstAvailable = (opt) => {
        if (!this.elements.input_groups.hasOwnProperty(opt)) return null;
        var opt_group = this.elements.input_groups[opt];
        var opts = opt_group.querySelectorAll('.swatch-element.available');
        for (let i = 0; i < opts.length; i++) {
            const element = opts[i];
            if (this.isAvailableOption(element)) return element.dataset.value;
        }

        return null;
    }

    getDefaultOptsFor = (material = null) => {
        if (material == null) material = this.material;
        if (material.includes('download')) material = 'download';
        return _.extend({}, this.defaults[material] || this.defaults['empty']);
    }

    onOptionsChanged = (opt, orig_val, new_val) => {
        if (orig_val != new_val) {
            if (opt == 'material') {
                this.resetOptions({material: new_val});
                return;
            }
        }
        if (this.isDownload()) {
            this.hideOptionGroup('size');
            this.hideOptionGroup('frame_type');
            this.hideOptionGroup('frame_finish');
            this.hideOptionGroup('mat');
        } else {
            this.showOptionGroup('size');
            let smallest_size = this.elements.inputs.size[0].dataset.value;
            let smallest_size_input = this.elements.inputs.size[0].querySelector('input');
            let second_size_input = this.elements.inputs.size[1].querySelector('input');
            let first_frame_finish = this.elements.inputs.frame_finish[1].querySelector('input');
            let third_frame_input = this.elements.inputs.frame_type[2].querySelector('input');
          
            this.hideGroupWhen('material', 'paper', 'frame_type');
            this.hideGroupWhen('material', 'canvas', 'mat');
            this.hideGroupWhen('material', 'canvas', 'frame_finish');
            this.disableOptionWhen('material','canvas','frame_finish','no frame');
            if (this.isPaper()) {
                this.disableOptionWhen('size', smallest_size, 'mat', 'with mat');
                this.disableOptionWhen('mat', 'with mat', 'size', smallest_size);
                this.hideGroupWhen('frame_finish', 'no frame', 'mat');
                this.showOption('frame_finish', 'no frame');
            }

            if (this.isCanvas()) {
                this.disableOptionWhen('size', smallest_size, 'frame_type', 'stretched');
                this.disableOptionWhen('size', smallest_size, 'frame_finish', 'rolled');
                //this.disableOptionWhen('size', smallest_size, 'frame_type', 'float');
              	this.hideOptionWhen('frame_finish', 'Classic Gold', 'frame_type','float');
              	this.hideOptionWhen('frame_type', 'float', 'frame_finish', 'Classic Gold');
                if ((this.frame_type || '').toLowerCase() == 'stretched' || (this.frame_finish || '').toLowerCase() == 'rolled') {
                  this.hideOptionGroup('frame_finish');
                  this.disableOption('size', smallest_size);
                } else {
                  this.showOptionGroup('frame_finish');
                  this.enableOption('size', smallest_size);
                }
                if ((this.frame_type || '').toLowerCase() == 'stretched' || (this.frame_finish || '').toLowerCase() == 'rolled' || (this.frame_type || '').toLowerCase() == 'float') {
                  //console.log('this is testing')
                  if (smallest_size_input.checked) {
                      second_size_input.click();
                      second_size_input.checked = true;
                  }
                  this.disableOption('size', smallest_size);
                } else{
                  this.enableOption('size', smallest_size);
                }
                //these lines added because default selection null when float is selected
                if ((this.frame_type || '').toLowerCase() == 'rolled'){
                  console.log(this.frame_type)
                  third_frame_input.click();
                  third_frame_input.checked = true;
                }
                this.hideOption('frame_finish', 'no frame');
                
            }

            if (['frame_type','frame_finish'].includes(opt)) this.updateFrameOptionImages();
            if (opt == 'frame_type' && this.isCanvas() && new_val != null) this.options = { frame_finish: 'White', mat: null};
            //when frame_type "stretched" is selected then frame_finish must "no frame"
            if (opt == 'frame_type' && (new_val || '').toLowerCase() == 'stretched') this.options = { mat: 'No Mat', frame_finish: 'no frame' };
            if (opt == 'frame_finish' && (new_val || '').toLowerCase() == 'no frame') this.options = { mat: 'No Mat' };
            if (opt == 'frame_finish' && (new_val || '').toLowerCase() == 'rolled') this.options = { frame_type: null, mat: 'No Mat' };
        }
    }

    updateImageDisplay = () => {
        var class_string = this.getDynamicFrameClass();
        this.elements.dynamic_frames.forEach(frame => {
            frame.dataset.frame = class_string;
            if (class_string) {
                frame.classList.add('has-frame');
                frame.style.paddingTop = '0';

                if (this.isCanvas()) {
                    if (this.mat === 'With Mat') {
                        frame.classList.add('frame-is-float');
                    } else {
                        frame.classList.remove('frame-is-float');
                    }
                }
            } else {
                frame.classList.remove('has-frame');
            }
        });
        this.updateProductImage();
        this.updateImageRatio();
    }

    updateProductImage = () => {
    }

    getDynamicFrameClass = () => {
        let class_string = '';
        if (this.frame_finish) class_string += this.handlize(this.frame_finish);

        if (this.isCanvas()) {
            if (this.frame_type === 'Float') {
                class_string += '_f';
            } else if (this.frame_type === 'Mounted') {
                class_string += '_nm'; // mount uses the same as paper print's "No Mat" frame
            } else {
                class_string += 'no-finish_s';
            }
        } else {
            if (this.hasMat()) {
                class_string += '_m';
            } else {
                class_string += '_nm';
            }
        }
        return class_string;
    }

    getImageRatio = () => {
        return this.aspect_ratios[this.size] || null;
    }

    updateImageRatio = () => {
        let ratio = this.getImageRatio();
        this.elements.image_wrappers.forEach(w => {
            if (ratio === null) delete w.dataset['aspectRatio']
            else w.dataset['aspectRatio'] = ratio;
        })
    }

    updateFrameOptionImages = () => {
        let color = this.handlize(this.frame_finish || '');
        if (color == 'no-frame' || color == 'rolled' || color == '') color = 'white';
        let type = this.handlize(this.frame_type || '');
        if (type == 'stretched' || this.isPaper()) type = 'mounted';

        this.elements.inputs.frame_type.forEach(el => {
            let img_name, label, val;
            val = el.dataset.value.toLowerCase();
            label = el.querySelector('label');
            if (val != 'stretched') {
                img_name = (color + '_fr_' + val).replace(/[ -]/g, '_');
                label.style.backgroundImage = `url("${this.frame_images[img_name]}")`;
            }
        });

        const available_frame_finishes = this.all_options
            .filter(opt => opt.name.includes('Finish')) //get frame finish options
            .flatMap(opt => opt.values) //get values list from each option and flatten to array
            .filter((val, i, arr) => arr.indexOf(val) == i) //remove duplicates
            .map(value => value.toLowerCase())

        this.elements.inputs.frame_finish.forEach(el => {
            let img_name, label, val;
            val = el.dataset.value.toLowerCase();
            label = el.querySelector('label');
            if (val != 'no frame') {
                img_name = (val + '_fr_' + type).replace(/[ -]/g, '_');
                label.style.backgroundImage = `url("${this.frame_images[img_name]}")`;
            }

            if (!available_frame_finishes.includes(val)) {
                el.style.display = 'none';
            }
        });
    }

    _handleClick = (e) => {
        let input, option, value;
        input = e.currentTarget;
        if (!(
            !this.isOptionElement(input) ||
            this.isDisabledOption(input) ||
            this.isHiddenOption(input) ||
            e.target !== input.firstElementChild
        )) {
            option = input.dataset.option;
            value = input.dataset.value;

            switch (option) {
                case 'choose-material': this.options = { material: value }; break;
                case 'choose-size-w-h': this.options = { size: value }; break;
                case 'frame-finish': this.options = { frame_finish: value }; break;
                case 'frame-type': this.options = { frame_type: value }; break;
                case 'mat': this.options = { mat: value }; break;
            }
        }
    }

    handlize = (str) => {
        return str.toLowerCase().replace(/([^a-z0-9]+)/g, ' ').trim().replace(/ /g, '-');
    }

    getQueryOptions = (filtered = false) => {
      	let initial = {};
      	if (!filtered) initial = this.getDefaultOptsFor('empty');
      	let params = [...(new URLSearchParams(window.location.search))];
      	return _.extend(initial,_.pick(params.reduce((opts, opt) => {
        	if (['material','size','frame_finish','frame_type','mat','variant'].includes(opt[0])) {
            	return { ...opts, [opt[0]]: decodeURIComponent(opt[1]) };
        	}
			return opts;
		}, {}), ['variant',...Object.keys(this.options)]));
    }

    getProductOptions = function(product_id) {
      var product = this.related_products.find(p => (p.id == product_id));
      return Object.entries(product.options).reduce((opts, opt) => {
        let opt_name = '';
        switch(opt[1].name) {
          case 'Choose Size (W/H)':
              opt_name = 'size';
              break;
          case 'Mat':
              opt_name = 'mat';
              break;
          case 'Frame Type':
              opt_name = 'frame_type';
              break;
          case 'Material':
              opt_name = 'material';
              break;
          case 'Frame Finish':
              opt_name = 'frame_finish';
              break;
        }
        opts['option'+opt[1].position] = opt_name;
        return opts
      }, {})
    }

    getVariantOptions = (variant_id) => {
      let variant = this.getVariant(variant_id);
      let opt_map = this.getProductOptions(variant.product_id);
      let options = {};
      options[opt_map.option1] = variant.option1;
      options[opt_map.option2] = variant.option2;
      options[opt_map.option3] = variant.option3;
      options.material = 'paper';
      if (variant.option1 == 'Digital Download') {
        options.material = 'digital download';
      } else if (opt_map.option2 == 'frame_type') {
        options.material = 'canvas';
      }
      return options;
    }

    getVariantMaterial = (variant) => {
      let type = 'paper no mat';
      for(var i in this.related_products) {
        if (this.related_products[i].id == variant.product_id) {
          type = this.related_products[i].product_type.toLowerCase();
        }
      }
      if (type.includes('paper')) return 'paper';
      if (type.includes('canvas')) return 'canvas';
      return 'digital_download'
    }

    updateUrl = () => {
        let query = new URLSearchParams(window.location.search);
        let to_delete = [];

        Object.entries(this.options).forEach(opt => query.set.apply(query, opt));
        query.forEach((v,k) => (v == 'null' && to_delete.push(k)));
        to_delete.forEach(query.delete.bind(query))

        window.history.replaceState({}, document.title, "?"+query.toString());
    }

    isDownload = () => {
        return this.material != null && this.material.toLowerCase().includes('download');
    }

    isPaper = () => {
        return this.material != null && this.material.toLowerCase() == 'paper';
    }

    isCanvas = () => {
        return this.material != null && this.material.toLowerCase() == 'canvas';
    }

    isLandscape = () => {
        return this.product.tags.includes('Landscape');
    }
    isPortrait = () => {
        return this.product.tags.includes('Portrait');
    }
    isLightWoodFrame = () => {
        return this.product.handle.includes('light-wood-frame');
    }

    hasFrame = () => {
        if (this.isPaper()) {
            return (this.frame_finish !== null && this.frame_finish.toLowerCase() != 'no frame');
        }
        if (this.isCanvas()) {
            return (this.frame_type !== null && this.frame_type.toLowerCase() != 'stretched' && this.frame_type.toLowerCase() != 'rolled');
        }
        return false;
    }

    hasMat = () => {
        return this.mat !== null && this.mat.toLowerCase() !== 'no mat';
    }

    hideOptionGroup = (opt_name) => {
        if (Object.hasOwnProperty.call(this.elements.input_groups, opt_name)) {
            let el = this.elements.input_groups[opt_name];
            el.classList.add('hide-swatch');
        }
    }

    showOptionGroup = (opt_name) => {
        if (Object.hasOwnProperty.call(this.elements.input_groups, opt_name)) {
            let el = this.elements.input_groups[opt_name];
            el.classList.remove('hide-swatch');
            let first_opt = el.querySelector('div[data-option]:not(.hide-swatch)');
            if (first_opt != null && this[first_opt.dataset.option] == null) {
                this[first_opt.dataset.option] = first_opt.dataset.value;
            }
        }
    }

    disableOption = (opt, val) => {
        if (Object.hasOwnProperty.call(this.elements.inputs, opt)) {
            this.elements.inputs[opt].forEach((el) => {
                if (el.dataset.value.toLowerCase() == val.toLowerCase()) {
                    el.classList.add('disable-swatch');
                }
            });
        }
    }

    enableOption = (opt, val) => {
        if (Object.hasOwnProperty.call(this.elements.inputs, opt)) {
            this.elements.inputs[opt].forEach((el) => {
                if (el.dataset.value.toLowerCase() == val.toLowerCase()) {
                    el.classList.remove('disable-swatch');
                }
            });
        }
    }

    hideOption = (opt, val) => {
        if (Object.hasOwnProperty.call(this.elements.inputs, opt)) {
            this.elements.inputs[opt].forEach((el) => {
                if (el.dataset.value.toLowerCase() == val.toLowerCase()) {
                    el.classList.add('hide');
                }
            });
        }
    }

    showOption = (opt, val) => {
        if (Object.hasOwnProperty.call(this.elements.inputs, opt)) {
            this.elements.inputs[opt].forEach((el) => {
                if (el.dataset.value.toLowerCase() == val.toLowerCase()) {
                    el.classList.remove('hide');
                }
            });
        }
    }

    disableOptionWhen = (opt, val, dep_opt, dep_val, invert = false) => {
        let disable = ((this[opt] || '').toLowerCase() == val.toLowerCase() && !invert);
        if (disable) {
            this.disableOption(dep_opt, dep_val);
        } else {
            this.enableOption(dep_opt, dep_val);
        }
    }

    hideOptionWhen = (opt, val, dep_opt, dep_val, invert = false) => {
        let disable = ((this[opt] || '').toLowerCase() == val.toLowerCase() && !invert);
        if (disable) {
            this.hideOption(dep_opt, dep_val);
        } else {
            this.showOption(dep_opt, dep_val);
        }
    }

    hideGroupWhen = (opt, val, dep, invert = false) => {
        let hide = ((this[opt] || '').toLowerCase() == val.toLowerCase() && !invert);
        if (hide) {
            this.hideOptionGroup(dep);
        } else {
            this.showOptionGroup(dep);
        }
    }

    isOptionElement = (el) => {
        return el instanceof HTMLElement && Object.hasOwnProperty.call(el.dataset, 'option');
    }

    isDisabledOption = (el) => {
        return (el.classList.contains('disable-swatch'));
    }

    isAvailableOption = (el) => {
        return (this.isOptionElement(el) && !this.isDisabledOption(el) && !this.isHiddenOption(el));
    }

    isHiddenGroup = (el) => {
        return (el.classList.contains('hide-swatch'));
    }

    isHiddenOption = (el) => {
        return (el.closest('.hide-swatch') != null);
    }

    upperCaseWords = (str) => {
        return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
            return $1.toUpperCase();
        });
    }

    updateVariant = () => {
        let variant = this.getVariant();
        //console.log(variant)
        if (variant) {
            this.log('Found variant', Object.assign({
                product_id: variant.product_id,
                variant_id: variant.id,
                title: variant.title,
                sku: variant.sku
            }, Object.fromEntries(Object.entries(variant).filter(([key, value]) => (key.startsWith('option'))))));
            this.product = this.related_products.find(p => (p.id == variant.product_id));
            this.updateTabContent();
        } else {
            this.log('Unable to find variant');
            return;
        }
        this.elements.variant_id_inputs.forEach(i => {i.value = variant.id});
        //this.elements.product_id_inputs.forEach(i => {i.value = variant.product_id});
        //console.log(variant.product_id)

        let price = variant.price;
        let compare = variant.compare_at_price;
        
        this.elements.price.regular.forEach(el => { el.textContent = '$'+price });
        this.elements.price.sale.forEach(el => { el.textContent = '$'+price });
        this.elements.price.compare.forEach(el => { el.textContent = '$'+compare });
        if (compare == null) {
            //console.log('get price:' +compare)
            if (this.elements.price.container.length) {
                this.elements.price.container.forEach(el => {
                    el.classList.remove('f-price--on-sale');
                });
            }
            [].forEach.call(this.elements.price.all_containers, function(el){
                if (el) el.classList.remove('f-price--on-sale');
            });
        } else {
            console.log('compare price:' +compare)
            if (this.elements.price.container.length) {
                this.elements.price.container.forEach(el => {
                    el.classList.add('f-price--on-sale');
                });
            }
            [].forEach.call(this.elements.price.all_containers, function(el){
                if (el) el.classList.add('f-price--on-sale');
            });
        }
    }

    updateTabContent = () => {
        this.elements.product_tabs_container.classList.remove('paper','canvas','portrait','landscape','light-wood-frame');
        let classes = [];
        if (this.isCanvas()) classes.push('canvas');
        if (this.isPaper() || this.isDownload()) classes.push('paper');
        if (this.isLandscape()) classes.push('landscape');
        if (this.isPortrait()) classes.push('portrait');
        if (this.isLightWoodFrame()) classes.push('light-wood-frame');

        this.elements.product_tabs_container.classList.add(...classes);
    }

    getType = () => {
        let ptype;
        if (this.isPaper()) {
            ptype = 'Paper ';
            if (this.hasFrame()) {
                ptype += this.hasMat() ? 'With Mat' : 'No Mat';
            } else {
                ptype += 'Non Framed';
            }
        } else if (this.isCanvas()) {
            ptype = 'Canvas ';
            if (this.hasFrame()) {
                ptype += this.frame_type;
            } else {
                ptype += 'Non Framed';
                
            }
        } else {
            ptype = 'digital download';
        }
        return this.upperCaseWords(ptype);
    }

    getOptionFromVal = (val) => {
        if (/[0-9]+x[0-9]+/.test(val)) return 'size';
        if (val.toLowerCase().includes('mat')) return 'mat';
        if (val.toLowerCase().includes('download') || ['canvas','paper'].includes(val.toLowerCase())) return 'material';
        if (['white','black','natural','espresso','gold', 'classic gold','no frame','rolled'].includes(val.toLowerCase())) return 'frame_finish';
        if (['stretched','mounted','float'].includes(val.toLowerCase())) return 'frame_type';
        return null;
    }

    compareOption = (key, val) => {
        if (this.options.hasOwnProperty(key)) {
            if (this.options[key] == null && val == null) return true;
            if (this.options[key] == null || val == null) return false;
            if (key == 'material' && val.toLowerCase() == 'digital download' && this.material.toLowerCase().includes('download')) return true;
            return this.options[key].toLowerCase() == val.toLowerCase();
        }
        return false;
    }

    getVariant = (variant_id = null) => {
        let type = this.getType();
        let variants = this.variants;
      	let variant = null;
      if (variant_id !== null) {
        variant = variants.find(v => (v.id == variant_id)) || null;
      } else {
        variants = this.related_products.find(p => {
            return p.product_type == type;
        }).variants;
        variant = (variants.find(v => {
          	for (let i = 1; i <= 3; i++) {
                let val = v['option'+i];
                let opt = this.getOptionFromVal(val);
                let opt_matches = this.compareOption(opt, val);
                if (!opt_matches) return false;
                if (val.toLowerCase().includes('download')) return true;
            }
            return true;
        }) || null);
      }
      return variant;
    }

    log = (...args) => {
        console.log(`%c[ ProductUI ]`, 'background:#201924;color: #2d2;', ...args);
    }

}